import { render, staticRenderFns } from "./Modules.List.vue?vue&type=template&id=19f946c3&"
import script from "./Modules.List.vue?vue&type=script&lang=js&"
export * from "./Modules.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports